function initHeaderDrawerTabs(root = document) {
  const menus = root.querySelectorAll('.header-drawer .finkid-tab.tabmenu');
  menus.forEach((menu) => {
    if (menu.dataset.tabsInit === '1') return;
    menu.dataset.tabsInit = '1';

    const buttons = Array.from(menu.querySelectorAll('.tab-button[data-tab-button-id]'));
    const panels = Array.from(menu.querySelectorAll('.tab-content[data-tab-content-id]'));

    if (!buttons.length || !panels.length) return;

    const activate = (id) => {
      buttons.forEach((b) => {
        const isActive = b.dataset.tabButtonId === id;
        b.classList.toggle('active', isActive);
        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach((p) => {
        const isActive = p.dataset.tabContentId === id;
        p.classList.toggle('active', isActive);
      });
    };

    // initial state
    const initial = buttons.find((b) => b.classList.contains('active')) || buttons[0];
    activate(initial.dataset.tabButtonId);

    buttons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        activate(btn.dataset.tabButtonId);
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initHeaderDrawerTabs());
document.addEventListener('shopify:section:load', (e) => initHeaderDrawerTabs(e.target));
document.addEventListener('shopify:block:select', (e) => initHeaderDrawerTabs(document));
